<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				Create link
			</div>
		</div>
		<div class="separator" />
		<div class="content create-link">
			<div class="main">
				<link-data-form
					ref="form"
					v-model="link"
					:is-waiting="isWaiting"
				/>
			</div>
			<div class="side">
				<div class="create-link--controls">
					<v2-button variant="red" @click="onCreate">
						Create
					</v2-button>
					<v2-button @click="onCancel">
						Cancel
					</v2-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import V2BackBtn from '@/components/v2/ui/V2BackBtn';
	import V2Button from '@/components/v2/ui/V2Button';
	import LinkDataForm from '@/components/dealLinks/LinkDataForm';
	import { DEAL_LINK_ACCESSIBILITY_OPTIONS } from '@/consts';
	import invalidFormMessage from '@/mixins/invalidFormMessage';
	import api from '@/services/api';

	export default {
		metaInfo: {
			title: 'Create link'
		},
		components: {
			V2BackBtn,
			V2Button,
			LinkDataForm
		},
		layout: 'v2default',
		mixins: [invalidFormMessage],
		data () {
			return {
				link: {
					name: '',
					enabled: true,
					expirationDate: null,
					accessibleBy: DEAL_LINK_ACCESSIBILITY_OPTIONS.PAYING_SUBSCRIBERS,
					token: null,
					deal_ids: []
				},
				isWaiting: undefined
			};
		},
		computed: {
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: '/teaching/links',
						text: 'Deal Links'
					},
					{
						path: '/teaching/links/create',
						text: 'Create'
					}
				];
			}
		},
		watch: {},
		created () {
			this.$store.commit('ui/setBreadcrumbs', {
				breadcrumbs: this.getBreadcrumbs
			});
			this.$store.commit('ui/setLoadingIsHidden');
		},
		methods: {
			async onCreate () {
				const valid = await this.$refs.form.validate();

				if (!valid) {
					this.showInvalidFormMessage();
				}

				this.isWaiting = 'handleSave';
				const response = await api.dealLinks.createDealLink({ link: this.link });
				if (response) {
					this.$store.commit('ui/showNotification', {
						notification: 'Created successfully.'
					});
					await this.$router.push(`/teaching/links/${response.id}`);
				}
				this.isWaiting = undefined;
			},
			onCancel () {
				this.$router.back();
			}
		}
	};
</script>

<style lang="scss" scoped>

.create-link {

  @media (max-width: 1279px) {
    display: flex;
    flex-direction: column;

    .side {
      width: 100%;
    }

    .main {
      width: 100%;
    }
  }

  &--title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 10px;
    @include font(18px, $c-darkest-navy, 700, 23px);
  }

  &--controls {
    display: flex;
    gap: 12px;

    .btn {
      border-radius: 4px;
      padding: 8px 20px;
      @include font(16px, $c-white-l, 500, 20px);
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-create {
      background: $c-red;
    }

    &-cancel {
      background: $c-dark-navy;
    }
  }
}

</style>
